<template>
  <div>
    <div class="company-item">
      <div class="title mb0" style="border: none">
        高管整体介绍：
      </div>
      <pre v-if="company.领导介绍" class="company-pre">{{ company.领导介绍 }}</pre>
    </div>
    <div class="investment-box">
      <div class="investment-box-search">
        <el-input
          v-model="keyword"
          placeholder="关键字搜索（全文）"
          size="small"
          class="investment-box-search-input"
          @keyup.enter.native="search"
        ></el-input>
        <el-button type="primary" size="small" class="investment-box-search-button" @click="search">搜索</el-button>
      </div>
      <div v-if="showCompanyLeaders && showCompanyLeaders.length > 0" class="investment-box">
        <div v-for="(item, i) in showCompanyLeaders" :key="`${item.姓名}${i}`" class="investment-item">
          <template v-if="item.来源 !== '企查查'">
            <div class="investment-icon">
              <img
                v-if="item.头像 && !item.头像.includes('default') && !item.头像.includes('Expires=')"
                :src="item.头像"
                alt=""
              />
              <img v-else src="../../../../company/src/NewFullCompany2.0/NewFullCompanyComponents/CompanyRadishes/default.png" alt="" />
              <el-tag type="success" size="small">公司高管</el-tag>
            </div>
            <div class="investment-content">
              <p>
                <span :class="{ 'drawer-link': item.rid, ft14: true }" @click="showRadish({ id: item.rid, item })">{{
                  item.姓名
                }}</span>
                <span style="margin-right: 10px; font-size: 14px">{{ item.目前职位 }}</span>
                <span
                  v-if="item.公司 && item.公司 !== company.简称"
                  class="info alpha-tag past-radish"
                  style="color: #a5a4a4"
                  >过往成员{{ item.公司 }}</span
                >
                <template v-if="item.职能模块">
                  <template v-if="Array.isArray(item.职能模块)">
                    <el-tag
                      v-for="(zhineng, zhinengIdx) in item.职能模块"
                      :key="zhinengIdx"
                      type="primary"
                      size="mini"
                      style="margin-right: 7px"
                      >{{ zhineng }}</el-tag
                    >
                  </template>
                  <el-tag v-else type="primary" size="mini">{{ item.职能模块 }}</el-tag>
                </template>
              </p>
              <p v-if="item.投资领域 && item.投资领域.length > 0" style="font-size: 12px">
                <span style="color: #999">投资领域：</span>
                {{ item.投资领域.join ? item.投资领域.join('，') : item.投资领域 }}
              </p>
              <template v-if="item.投资案例 && item.投资案例.length > 0">
                <p style="font-size: 12px; display: flex">
                  <span style="color: #999">投资案例：</span>
                  <span>
                    <span
                      v-for="(anli, anliIdx) in item.投资案例"
                      :key="anliIdx"
                      class="drawer-link"
                      @click="toBaidu(anli.名称)"
                      >{{ anli.名称 }}{{ anliIdx !== item.投资案例.length - 1 ? '，' : '' }}</span
                    >
                  </span>
                </p>
              </template>
              <p v-if="item.简介" style="font-size: 12px">
                <span style="color: #999">简&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;介：</span>
                <span class="intro">
                  <span
                    :ref="`${item._id}lines`"
                    :style="{
                      height: item.showMore === false ? '60px' : 'auto',
                      overflow: 'hidden',
                      textAlign: 'justify',
                    }"
                    >{{ item.简介 }}</span
                  >
                  <span v-if="item.lineNum > 3" class="show-more-btn-box">
                    <span v-if="!item.showMore" class="drawer-link" @click="item.showMore = !item.showMore"
                      ><i class="el-icon-arrow-down"></i>展示更多</span
                    >
                    <span v-else class="drawer-link" @click="item.showMore = !item.showMore"
                      ><i class="el-icon-arrow-up"></i>收起</span
                    >
                  </span>
                </span>
              </p>
            </div>
          </template>
          <template v-else>
            <div class="investment-icon">
              <img
                v-if="item.头像 && !item.头像.includes('default') && !item.头像.includes('Expires=')"
                :src="item.头像"
                alt=""
              />
              <img v-else src="../../../../company/src/NewFullCompany2.0/NewFullCompanyComponents/CompanyRadishes/default.png" alt="" />
            </div>
            <div class="investment-content">
              <p>
                <span :class="{ 'drawer-link': item.rid, ft14: true }" @click="showRadish({ id: item.rid, item })">{{
                  item.姓名
                }}</span>
                <span style="margin-right: 10px; font-size: 14px">{{ item.目前职位 }}</span>
                <span v-if="item.label === '过往成员'" class="info alpha-tag past-radish" style="color: #a5a4a4"
                  >过往成员</span
                >
                <template v-if="item.职能模块">
                  <template v-if="Array.isArray(item.职能模块)">
                    <el-tag
                      v-for="(zhineng, zhinengIdx) in item.职能模块"
                      :key="zhinengIdx"
                      type="primary"
                      size="mini"
                      style="margin-right: 7px"
                      >{{ zhineng }}</el-tag
                    >
                  </template>
                  <el-tag v-else type="primary" size="mini">{{ item.职能模块 }}</el-tag>
                </template>
              </p>
              <p v-if="item.投资领域" style="font-size: 12px">
                <span style="color: #999">投资领域：</span>
                {{ item.投资领域.join ? item.投资领域.join('，') : item.投资领域 }}
              </p>
              <template v-if="item.投资案例 && item.投资案例.length > 0">
                <p style="font-size: 12px; display: flex">
                  <span style="color: #999">投资案例：</span>
                  <span>
                    <span
                      v-for="(anli, anliIdx) in item.投资案例"
                      :key="anliIdx"
                      class="drawer-link"
                      @click="toBaidu(anli.名称)"
                      >{{ anli.名称 }}{{ anliIdx !== item.投资案例.length - 1 ? '，' : '' }}</span
                    >
                  </span>
                </p>
              </template>
              <p v-if="item.简介" style="font-size: 12px">
                <span style="color: #999">简&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;介：</span>
                <span class="intro">
                  <span
                    :ref="`${item.rid || item.姓名 + item.目前职位}lines`"
                    :style="{
                      height: item.showMore === false ? '60px' : 'auto',
                      overflow: 'hidden',
                      textAlign: 'justify',
                    }"
                    >{{ item.简介 }}</span
                  >
                  <span v-if="item.lineNum > 3" class="show-more-btn-box">
                    <span v-if="!item.showMore" class="drawer-link" @click="item.showMore = !item.showMore"
                      ><i class="el-icon-arrow-down"></i>展示更多</span
                    >
                    <span v-else class="drawer-link" @click="item.showMore = !item.showMore"
                      ><i class="el-icon-arrow-up"></i>收起</span
                    >
                  </span>
                </span>
              </p>
            </div>
          </template>
        </div>
      </div>
    </div>
    <el-pagination
      v-if="showCompanyLeaders && showCompanyLeaders.length > 0"
      :current-page="page"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      :total="total"
      background
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="pageSizeChange"
      @current-change="pageChange"
    />
  </div>
</template>
<script>

export default {
  props: {
    company: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      companyLeaders: [],
      qimingpianLeaders: [],
      qichachaLeaders: [],
      cateData: [],
      page: 1,
      pageSize: 50,
      companyInvestment: {},
      isAdmin: false,
      keyword: '',
    }
  },
  computed: {
    showCompanyLeaders() {
      const { page, pageSize, companyLeaders, qimingpianLeaders } = this
      const newArr = companyLeaders.concat(qimingpianLeaders).slice((page - 1) * pageSize, page * pageSize)
      newArr.forEach((n) => {
        if (n.投资案例 && n.投资案例.length > 0 && n.投资案例.filter((v) => v.名称).length > 0) {
          //
        } else {
          n.投资案例 = ''
        }
      })
      return newArr
    },
    total() {
      return this.companyLeaders.concat(this.qimingpianLeaders).length
    },
  },
  watch: {
    company: {
      handler: async function (newValue, oldVal) {
        if (newValue && newValue._id && newValue._id !== (oldVal && oldVal._id)) {
          if (!newValue.领军人物) {
            newValue.领军人物 = ''
          }
          await this.getCompanyLeaders(newValue.领导)
          await this.getQimingpian()
          await this.getQichacha()
        }
      },
      immediate: true,
    },
    showCompanyLeaders(newValue, oldVal) {
      if (newValue && newValue.length > 0) {
        this.$nextTick((_) => {
          for (const item of newValue) {
            let lineNum
            let showMore
            if (item._id) {
              lineNum =
                this.$refs[`${item._id}lines`] &&
                this.$refs[`${item._id}lines`][0] &&
                this.$refs[`${item._id}lines`][0].offsetHeight / 20
            } else if (item.rid) {
              lineNum =
                this.$refs[`${item.rid}lines`] &&
                this.$refs[`${item.rid}lines`][0] &&
                this.$refs[`${item.rid}lines`][0].offsetHeight / 20
            } else {
              lineNum =
                this.$refs[`${item.姓名 + item.目前职位}lines`] &&
                this.$refs[`${item.姓名 + item.目前职位}lines`][0] &&
                this.$refs[`${item.姓名 + item.目前职位}lines`][0].offsetHeight / 20
            }
            showMore = lineNum <= 3
            this.$set(item, 'lineNum', lineNum)
            this.$set(item, 'showMore', showMore)
          }
        })
      }
    },
  },
  async mounted() {
    this.isAdmin = app.user.角色 && app.user.角色.includes('管理员')
    if (!app.categories) await app.getCats()
    this.cateData = app.categories.map((cate) => cate['名称'])
  },
  methods: {
    search() {
      if (!this.keyword) {
        this.getCompanyLeaders(this.company.领导)
        this.getQimingpian()
      } else {
        this.companyLeaders = this.companyLeaders.filter((v) => {
          const str = JSON.stringify(v)
          return str.includes(this.keyword.trim())
        })
        this.qimingpianLeaders = this.qimingpianLeaders.filter((v) => {
          const str = JSON.stringify(v)
          return str.includes(this.keyword.trim())
        })
      }
      this.page = 1
    },
    toBaidu(keyword) {
      window.open(`https://baike.baidu.com/item/${keyword}`, '_blank')
    },
    showIntoProject(row) {
      if (!row.rid) {
        this.$alert('请先绑定', { showClose: false })
      }
      app.root.$refs.radishProDialog.show([{ _id: row.rid }], 'intoProject')
    },
    pageChange(val) {
      this.page = val
    },
    pageSizeChange(val) {
      this.pageSize = val
    },


    async getCompanyLeaders(leaders) {
      if (!leaders) {
        return
      }
      const res = await window.app.service('company').getLeaders(leaders)
      if (res.status === 'success') {
        this.companyLeaders = res.data
      } else {
        this.$message(res.msg)
        this.companyLeaders = []
      }
    },


    showRadish(opts) {
      if (!opts.id) {
        if (opts.item) {
          this.clickInvestment(opts.item)
        }
        return
      }
      window.open(`${window.frontend}/#/radish-detail-blank/${opts.id}`, '_blank')
    },
    async getQimingpian() {
      if (!this.company._id) return
      const res = await app.service('company').getCompanyInvestment({ cid: this.company._id })
      if (res.status === 'success') {
        this.companyInvestment = res.data
        const result = res.data.投资机构 || []
        const qimingpianLeaders = []
        result.forEach((e) => {
          const index = this.companyLeaders.findIndex((v) => v.姓名 == e.姓名)
          if (index > -1) {
            if (
              e.投资案例 &&
              this.companyLeaders[index] &&
              (!this.companyLeaders[index].投资案例 || this.companyLeaders[index].投资案例.length == 0)
            ) {
              this.companyLeaders[index].投资案例 = e.投资案例.split(',').map((v) => ({ 名称: v }))
            }
            if (e.头像) {
              this.companyLeaders[index].头像 = e.头像
            }
          } else {
            const obj = Object.assign({}, e)
            obj.目前职位 = e.职位
            obj.来源 = '企查查'
            if (obj.投资案例) {
              obj.投资案例 = obj.投资案例.split(',').map((v) => ({ 名称: v }))
            }
            qimingpianLeaders.push(obj)
          }
        })
        this.qimingpianLeaders = qimingpianLeaders
      } else this.qimingpianLeaders = []
    },
    async getQichacha() {
      if (!this.company.公司名称) return
      if (this.company.checkdata) {
        const employees = (this.company.checkdata && this.company.checkdata.Employees) || []
        employees.forEach((e) => {
          e.简介 = ''
        })
        const qichachaLeaders = []
        employees.forEach((e) => {
          if (this.companyLeaders.map((c) => c.姓名).includes(e.Name)) {
            // e.join = true
          } else {
            // e.join = false
            const obj = Object.assign({}, e)
            obj.来源 = '企查查'
            obj.姓名 = e.Name
            obj.目前职位 = e.Job
            qichachaLeaders.push(obj)
          }
        })
        this.qichachaLeaders = qichachaLeaders
      } else this.qichachaLeaders = []
    },
    async defaultSerchRadish() {
      this.$refs.addLeader.open()
    },
  },
}
</script>
<style src="../../../../company/statistics/css/fullCompanyDetail.css" scoped></style>
<style src="../../../../company/statistics/css/commonCompany.css" scoped></style>
<style scoped>
pre {
  text-indent: 0;
}
.company-leader-ochart.title {
  width: 250px;
  min-height: 90px;
  font-size: 14px;
  display: flex;
  align-items: center;
  background-color: #fff;
  padding-bottom: 0;
  border: 1px solid #ccc;
}
.ochart-radish,
.ochart-func {
  width: 40%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 5px;
  background-color: #ddd;
  color: #000;
  height: 100%;
  /* flex-grow: 1; */
}
.ochart-func {
  width: 60%;
  background-color: #fff;
}
.ochart-tags {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}
.company-item {
  padding-bottom: 16px;
  margin-bottom: 16px;
  border-bottom: 1px solid rgb(234, 234, 234);
  width: 100%;
}
.company-item:last-of-type {
  border: none;
}
.leader-from-core {
  margin-bottom: 10px;
}
.leader-from-core b {
  color: #333;
}
.leader-item {
  width: 100%;
  border: 1px solid rgb(234, 234, 234);
  border-radius: 4px;
  margin-bottom: 16px;
  padding: 10px;
  width: 100%;
}
.edit-dialog-wrap {
  border: 1px solid rgb(234, 234, 234);
  border-radius: 4px;
  padding: 10px;
  width: 100%;
  max-height: 260px;
  overflow-y: scroll;
}
.edit-dialog-wrap .leader-from-core span {
  margin: 0 5px;
  line-height: 20px;
}
.edit-dialog-wrap .leader-from-core span b {
  min-width: 0;
}
.search-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 50px;
  width: 100%;
}

.edit-dialog-part {
  display: flex;
  height: 600px;
}
.edit-dialog-left {
  flex: auto;
  overflow: auto;
  padding-right: 10px;
  display: flex;
  flex-direction: column;
}
.edit-dialog-right {
  flex: none;
  width: 400px;
  overflow: auto;
  background-color: #eee;
  padding: 10px;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.add-leader-header {
  flex: none;
}
.add-leader-content {
  flex: auto;
  overflow: auto;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  padding: 10px;
  border-radius: 4px;
}
.field-alert {
  color: #ff3300;
}
.warning-text {
  color: #ff3300;
}

.leader-ready-join {
  display: flex;
  align-items: flex-start;
  justify-content: space-around;
}
/* .leader-ready-join span{
  word-break: keep-all;
} */

.investment-box {
  height: calc(100% - 71px);
  /* background-color: #eff2f5; */
}
.investment-item {
  display: flex;
  background-color: #fff;
  margin-bottom: 6px;
  border: 1px solid rgb(234, 234, 234);
  width: 100%;
  padding: 10px;
  border-radius: 10px;
}
.investment-item .investment-icon {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 20px;
  flex-shrink: 0;
}
.investment-item .investment-icon img {
  width: 70px;
  height: 70px;
  margin-bottom: 10px;
  border-radius: 50%;
}
.investment-handle-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-left: 20px;
  width: 90px;
  flex-shrink: 0;
}
.investment-item .btn {
  max-width: 150px;
  min-width: 90px;
  text-align: center;
}
.investment-content {
  flex-grow: 1;
}
.investment-content p {
  padding: 3px 0;
  display: flex;
}
.investment-content p span {
  display: inline-block;
}
.investment-content p span:nth-child(1) {
  min-width: 64px;
}
.investment-content .intro {
  display: inline-block;
  line-height: 20px;
  flex-grow: 1;
}

.investment-content .show-more-btn-box {
  display: flex;
  justify-content: center;
}
.ft16 {
  font-size: 16px;
}
.ft14 {
  font-size: 14px;
}
.past-radish {
  margin-left: 6px;
}
.search-company {
  padding: 6px 10px;
  background-color: #fff;
}
.company-pre {
  background-color: #fff;
}
.investment-box-search {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.investment-box-search-input {
  flex-grow: 1;
  margin-right: 20px;
}
.investment-box-search-button {
  flex-shrink: 0;
}
</style>
